import { Component } from '@angular/core';
import { GridFilterBase } from '../grid-filter-base/grid-filter-base';

@Component({
  selector: 'spv2-grid-company-filter',
  templateUrl: './grid-company-filter.component.html',
  styleUrls: ['./grid-company-filter.component.scss']
})
export class GridCompanyFilterComponent extends GridFilterBase<string> {

}
